export {default} from "./Trophy"
export {default as CustomTrophy} from "./CustomTrophy"
